// src/utils/catalog.ts

// Limity backendu: zwrot dłuższy niż 200 znaków albo ponad 200 zwrotów w jednym zapytaniu dają 400 —
// w masowym uzupełnianiu na całą paczkę naraz. Front długości hasła nie ogranicza, więc pilnujemy tu.
export const MAX_CATALOG_TERM_LENGTH = 200;
export const MAX_LOOKUP_TERMS = 200;

// Pusty zwrot nie ma w katalogu czego szukać, za długi odbiłby się 400
export const isCatalogTerm = (term?: string): term is string => Boolean(
  term && term.trim() && term.length <= MAX_CATALOG_TERM_LENGTH,
);

// Paczki dla `POST /catalog/lookup`. Wynik trzeba potem dopasować po pozycji w paczce — odpowiedź
// nie niesie niczego, po czym dałoby się rozpoznać słowo.
export const chunkForLookup = <T>(items: T[]): T[][] => Array.from(
  { length: Math.ceil(items.length / MAX_LOOKUP_TERMS) },
  (_, index) => items.slice(index * MAX_LOOKUP_TERMS, (index + 1) * MAX_LOOKUP_TERMS),
);

// Jak przy proxy Unsplasha: sytuację rozpoznajemy po stabilnym `code`, nie po treści komunikatu
const ERROR_TRANSLATION_KEYS: Record<string, string> = {
  CATALOG_NOT_CURATOR: 'words-list:catalog.errors.notCurator',
  CATALOG_NO_TERM: 'words-list:catalog.errors.noTerm',
  CATALOG_SOURCE_NOT_ELIGIBLE: 'words-list:catalog.errors.sourceNotEligible',
  CATALOG_ASSET_NOT_FOUND: 'words-list:catalog.errors.assetNotFound',
  CATALOG_ENTRY_EXISTS: 'words-list:catalog.errors.entryExists',
  CATALOG_ENTRY_NOT_FOUND: 'words-list:catalog.errors.entryNotFound',
};

export const catalogErrorCode = (error: any): string | undefined => error?.response?.data?.code;

export const catalogErrorKey = (error: any): string => (
  ERROR_TRANSLATION_KEYS[catalogErrorCode(error) || ''] || 'words-list:catalog.errors.generic'
);
